import { ValueElement } from "./Base";
import { TextInputElement, TextInputType } from "./TextInput";
import { translate } from "../Helpers";

export default class NumericDateElement extends ValueElement {
    private day: TextInputElement;

    private month: TextInputElement;

    private year: TextInputElement;

    private instance: HTMLDivElement;

    private onDayValueChanged = () => this.onChange();

    private onMonthValueChanged = () => this.onChange();

    private onYearValueChanged = () => this.onChange();

    constructor(name: string,
                value: string,
                classes: string[],
                minYear: number = 1900) {
      super(name);
      this.instance = document.createElement("div");

      const values: string[] = value ? value.split('-') : [];

      this.day = new TextInputElement(`${name}_day`, values[2] || "", TextInputType.Number, classes, [
        { key: "min", value: "1" },
        { key: "max", value: "31" },
        { key: "maxlength", value: "2" },
        { key: "position", value: "day" },
        { key: "aria-label", value: `${name}_day` },
        { key: "date-field", value: "true" },
        { key: "placeholder", value: translate("field.birthdate_day.placeholder") }
      ]);
      this.day.addEventListener("valueChanged", this.onDayValueChanged);
      this.instance.appendChild(this.day.element);

      this.month = new TextInputElement(`${name}_month`, values[1] || "", TextInputType.Number, classes, [
        { key: "min", value: "1" },
        { key: "max", value: "12" },
        { key: "maxlength", value: "2" },
        { key: "position", value: "month" },
        { key: "aria-label", value: `${name}_month` },
        { key: "date-field", value: "true" },
        { key: "placeholder", value: translate("field.birthdate_month.placeholder") }
      ]);
      this.month.addEventListener("valueChanged", this.onMonthValueChanged);
      this.instance.appendChild(this.month.element);

      this.year = new TextInputElement(`${name}_year`, values[0] || "", TextInputType.Number, classes, [
        { key: "min", value: minYear.toString() },
        { key: "max", value: new Date().getFullYear().toString() },
        { key: "maxlength", value: "4" },
        { key: "position", value: "year" },
        { key: "aria-label", value: `${name}_year` },
        { key: "date-field", value: "true" },
        { key: "placeholder", value: translate("field.birthdate_year.placeholder") }
      ]);
      this.year.addEventListener("valueChanged", this.onYearValueChanged);
      this.instance.appendChild(this.year.element);
    }

    get element(): HTMLElement {
      return this.instance;
    }

    get value(): any {
      return `${this.year.value}-${this.month.value.padStart(2, "0")}-${this.day.value.padStart(2, "0")}`;
    }

    set value(val: any) {
      const [year, month, day] = String(val ?? "").split("-");
      this.year.value = year || "";
      this.month.value = month || "";
      this.day.value = day || "";
    }

    dispose(): void {
      this.day.removeEventListener("valueChanged", this.onDayValueChanged);
      this.month.removeEventListener("valueChanged", this.onMonthValueChanged);
      this.year.removeEventListener("valueChanged", this.onYearValueChanged);
    }

    disable(): void {
      (this.day.element as HTMLInputElement).disabled = true;
      (this.month.element as HTMLInputElement).disabled = true;
      (this.year.element as HTMLInputElement).disabled = true;
    }
}
